/* eslint-disable max-lines */
import gql from "graphql-tag.macro";

const queryLoadActionLogs = gql`
    query loadActionLogs {
        actionLogs {
            edges {
                node {
                    index
                    hash
                    timestamp
                    data {
                        comment
                        who {
                            id
                            email
                        }
                        when
                        why {
                            human
                            robot {
                                relatedId
                                relatedKind
                                from
                                to
                                by
                            }
                        }
                        what {
                            path
                            value
                            from
                        }
                    }
                }
            }
        }
    }
`;

const approveActionLogs = gql`
    query approveActionLogs {
        approveActionLogs {
            _id
            comment
            statusChangedAt
            customstatus
            customstati
            status
            _meta {
                ownerInfo {
                    email
                    firstname
                    lastname
                }
            }
        }
    }
`;

export const loadApprovalHistory = async ({ client }) => {
    const {
        data: {
            actionLogs: { edges: data },
        },
    } = await client.query({
        query: queryLoadActionLogs,
        fetchPolicy: "no-cache",
    });
    return data;
};

export const loadApproveActionLogs = async ({ client }) => {
    const {
        data: { approveActionLogs: data },
    } = await client.query({
        query: approveActionLogs,
        fetchPolicy: "no-cache",
    });
    return data;
};
